import { DialogContent, Dialog, DialogTitle, IconButton, useMediaQuery } from "@mui/material"
import CloseIcon from '@mui/icons-material/Close';
import { useEffect } from "react"
import { useAppTheme } from "../../../logic/useAppTheme";

export function EarnestMoneyDialog({regCode, interactionPrefix, interactionSuffix, onClosed }: {regCode: string, interactionPrefix: string, interactionSuffix: string, onClosed: () => void}) {

  const DepositrComponent = 'depositr-app' as React.ElementType

  const theme = useAppTheme() 
  const isSmall = useMediaQuery(theme.breakpoints.down('sm'))
  const primaryColor = theme.palette.primary.main

  useEffect(() => {
    const script = document.createElement('script')
    script.src = process.env.REACT_APP_FOURTIER_CLIENT_URL || 'https://testr.depositr.io/element/deposiTR.js'
    script.id = "deposiTR"
    script.setAttribute("regCode", regCode)
    script.setAttribute("interactionPrefix", interactionPrefix)
    script.setAttribute("interactionSuffix", interactionSuffix)

    document.head.appendChild(script)

    // Clean up when component unmounts
    return () => {
      document.head.removeChild(script)
    }
  }, [regCode, interactionPrefix, interactionSuffix])

  function onDialogClose() {
    onClosed()
  }

  return (
    <Dialog
      open={true}
      fullScreen={isSmall ? true : false}
      disableEscapeKeyDown={true}
      sx={{
        height: '100%',
        padding: { xs: '8px' },
        '& .MuiDialog-paper': { borderRadius: '20px', height: '100%' }
      }}
      fullWidth={true}
      maxWidth='xl'
    >

      <DialogTitle sx={{
        'borderBottom': `1px solid ${primaryColor}`,
        display: 'flex', alignItems: 'center',
        justifyContent: 'space-between',
      }}>
          Earnest Money Deposit
        <IconButton
          aria-label="close"
          onClick={onDialogClose}
          sx={{
            position: 'absolute',
            right: 8,
            top: 10,
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent>
        <DepositrComponent id="deposiTR"></DepositrComponent>
      </DialogContent>
    </Dialog>
  );
}
